<template>
  <div class="block-wrapper">
    <label class="label-wrapper cursor-pointer">
      <input
        type="checkbox"
        class="checkbox border border-solid border-background-color-4"
        :checked="modelValue || value"
        @input="handleChange($event.target.checked)"
      />
      <slot name="label" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: String,
      default: 'mr-[10px]',
    },
  },

  emits: ['input', 'update:modelValue'],

  methods: {
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('update:modelValue', value)
    },
  },
}
</script>

<style scoped lang="scss">
.label-wrapper {
  display: flex;
  align-items: center;
}

.checkbox {
  cursor: pointer;
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: #1a1a1a;
  border-radius: 6px;
  position: relative;
  flex-shrink: 0;
}

.checkbox:checked {
  background-color: var(--brand);
}

.checkbox:checked::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 7px;
  width: 5px;
  height: 10px;
  border: solid black;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
